var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeleteinline = function SvgDeleteinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    d: "M5.23 12.663a.576.576 0 0 0 .576-.568V7.47a.576.576 0 1 0-1.152 0v4.626a.576.576 0 0 0 .576.567M8 12.664a.576.576 0 0 0 .576-.568V7.47a.576.576 0 1 0-1.152 0v4.626a.576.576 0 0 0 .576.568M10.77 12.664a.576.576 0 0 0 .575-.568V7.47a.576.576 0 1 0-1.152 0v4.626a.575.575 0 0 0 .576.568"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#21201F",
    d: "M14.924 2.83h-3.686l-.474-1.588a1.69 1.69 0 0 0-1.607-1.2H6.845a1.69 1.69 0 0 0-1.607 1.2l-.474 1.589H1.076a.576.576 0 1 0 0 1.151h.686V15.07a1.59 1.59 0 0 0 1.588 1.58h9.319a1.59 1.59 0 0 0 1.588-1.588V3.963h.667a.576.576 0 0 0 .576-.576.56.56 0 0 0-.576-.557M6.353 1.573a.54.54 0 0 1 .492-.378h2.328a.514.514 0 0 1 .501.38l.37 1.257h-4.09zm6.752 13.615h-.04a.45.45 0 0 1-.413.3H3.35a.447.447 0 0 1-.44-.445V3.964h10.195z"
  })));
};
export default SvgDeleteinline;